<template>
  <b-form-group
    label="Hizmet Şekli"
    label-for="id_service_types"
  >
    <validation-provider
      #default="{ errors }"
      name="Hizmet Şekli"
      rules="required"
    >
      <v-select
        id="id_service_types"
        v-model="dataItem.id_service_types"
        :options="serviceTypes"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ServiceTypes',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['services/dataItem']
    },
    serviceTypes() {
      return this.$store.getters['serviceTypes/dataList']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('serviceTypes/getDataList', {
        select: [
          'service_types.id AS id',
          'service_types.title AS title',
        ],
      })
    },
  },
}
</script>
